import { render } from "./EditAward.vue?vue&type=template&id=118fe48a"
import script from "./EditAward.vue?vue&type=script&lang=js"
export * from "./EditAward.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__